module.exports = __webpack_public_path__ + "img/6-ilpakamanioMASYmas_thumb.4301e026.jpg";